import {
	CapabilityResolver,
	CapabilityRole,
	CapabilityRoleValues,
	CapabilityType,
} from "./../models/auth_user";
import {
	AppuntamentiFilters,
	AppuntamentoCup,
	PrescrizioneCup,
} from "./../../cup/cup_models";
import { CategoriaEsame } from "./../models/esame";
import {
	InfoPagina,
	ParolaChiave,
	MacrotemaFaq,
	CategoriaFaq,
	SottoCategoriaFaq,
	Faq,
} from "./../models/info";
import { AreaVasta, REGIONE_TOSCANA_ID } from "./../models/anagrafica_geo";
import { Gravidanza, ProfiloUtente } from "./../models/gravidanza";
import {
	Regione,
	Provincia,
	Comune,
	Distretto,
	AziendaSanitaria,
	Macrozona,
} from "../models/anagrafica_geo";
import { AuthUser, UserCapability } from "../models/auth_user";
import {
	throwError as observableThrowError,
	Observable,
	of,
	Subject,
} from "rxjs";
import { MultiLangString } from "../models/lingua_sistema";
import { Injectable, EventEmitter } from "@angular/core";

import {
	HttpClient,
	HttpHeaders,
	HttpRequest,
	HttpParams,
} from "@angular/common/http";

import {
	Struttura,
	TipologiaStruttura,
	TipoServizioStruttura,
} from "../models/struttura";
import {
	Utente,
	AutorizzazioneOperatore,
	AutorizzazioneDistretto,
	DescrizioneMedicoFamiglia,
} from "../models/utente";

import { BASE_PATH_SERVER, pathJoin } from "@src/environments/configs";
import { LinguaSistema } from "../models/lingua_sistema";
import {
	Deserializable,
	HmModelRest,
	HmRestType,
	HmType,
} from "../models/abstract_model";
import { Router, DefaultUrlSerializer } from "@angular/router";

import * as _ from "lodash";
import { NbAuthService } from "@nebular/auth";
import {
	Cittadinanza,
	Professione,
	TitoloStudio,
} from "../models/dettaglio_profilo";
import { MessaggioHome } from "../models/info";
import { Esame } from "../models/esame";
import { filter, map } from "rxjs/operators";
import { SchemaPrestazione } from "../models/prestazione";
import { AgendaUtente } from "../models/agenda_utente";
import { UserListEntry } from "../models/user_listentry";
import { Operatore } from "../models/operatore";
import {
	BMI,
	classePeso,
} from "@hm_app/admin/percorso-nascita/libretto-gravidanza/utils_libretto";
import { CategoriaAssistenza } from "@hm_app/hm-auth/hm-assistenza/models";
import { OperatoreDistretto } from "../models/team_operatori";

export function filterFirst(res_array) {
	if (_.isArray(res_array)) return res_array.length > 0 ? res_array[0] : null;
	else return res_array;
}

function customDeserializeJson<T>(classType: HmType<T>, entry): T {
	return _.assignInWith(new classType(), entry, (objValue, srcValue) => {
		// console.log(objValue, srcValue, key, object, source);
		if (srcValue == null) return null;

		if (typeof (srcValue == "object") && srcValue["it"] != null) {
			const res = _.assignInWith(new MultiLangString(), srcValue);
			return res;
		}

		return srcValue;
	});
}

@Injectable()
export class HappyMammaService implements CapabilityResolver {
	private baseUrl = BASE_PATH_SERVER;

	current_struttura_gravidanza: Struttura;

	updateAgenda: EventEmitter<String> = new EventEmitter<any>();
	updateAgendaObject: EventEmitter<AgendaUtente> =
		new EventEmitter<AgendaUtente>();

	postFile(faqId: number, fileToUpload: File): Observable<any> {
		const url = this.baseUrl + "/informazioni/" + faqId + "/uploadimage/";
		const formData: FormData = new FormData();
		formData.append("file", fileToUpload, fileToUpload.name);
		return this.http.post(url, formData);
	}

	cancelFile(faqId: number): Observable<any> {
		const url = this.baseUrl + "/informazioni/" + faqId + "/uploadimage/";
		const formData: FormData = new FormData();
		formData.append("file", null, "name");
		return this.http.post(url, null);
	}

	updateAgendaReservation(agenda: AgendaUtente): Observable<any> {
		const url = this.baseUrl + "/agende_utente/";
		return this.http.put(url, agenda, { headers: this.getJSONHeader() });
	}

	comuniAll: Comune[];
	async comuniAllPromise(): Promise<Comune[]> {
		if (!this.comuniAll) {
			const c = await this.getAll<Comune>(Comune).toPromise();
			this.comuniAll = _.orderBy(c, "nome");

			// console.info("fetched comuni for cache");
		}
		return this.comuniAll;
	}

	provinceToscanaAll: Provincia[];
	async provinceToscanaAllPromise(): Promise<Provincia[]> {
		if (!this.provinceToscanaAll) {
			const p = await this.getAll<Provincia>(Provincia, {
				regione: REGIONE_TOSCANA_ID,
			}).toPromise();
			this.provinceToscanaAll = _.orderBy(p, "nome");
			// console.info("fetched provinceToscana for cache");
		}
		return this.provinceToscanaAll;
	}

	comuniToscanaAll: Comune[];
	async comuniToscanaAllPromise(): Promise<Comune[]> {
		if (!this.comuniToscanaAll) {
			const province_toscana = await this.provinceToscanaAllPromise();
			const ids = _.map(province_toscana, "id");
			const c = await this.getAll<Comune>(Comune, {
				provincia: ids,
			}).toPromise();
			this.comuniToscanaAll = _.orderBy(c, "nome");
			// console.info("fetched comuni toscana for cache");
		}
		return this.comuniToscanaAll;
	}

	distrettiAll: Distretto[];
	async distrettiAllPromise(): Promise<Distretto[]> {
		if (!this.distrettiAll) {
			const d = await this.getAll<Distretto>(Distretto).toPromise();
			this.distrettiAll = _.orderBy(d, "nome");
			// console.info("fetched distretti for cache");
		}
		return this.distrettiAll;
	}

	async distrettiWithMacrozonaPromise(): Promise<Distretto[]> {
		if (!this.distrettiAll) {
			const d = await this.getAll<Distretto>(Distretto).toPromise();
			this.distrettiAll = _.orderBy(d, "nome");
			// console.info("fetched distretti for cache");
		}
		return this.distrettiAll.filter((d) => d.macrozona);
	}

	provinceAll: Provincia[];
	async provinceAllPromise(): Promise<Provincia[]> {
		if (!this.provinceAll) {
			const p = await this.getAll<Provincia>(Provincia).toPromise();
			this.provinceAll = _.orderBy(p, "nome");
			// console.info("fetched province for cache");
		}
		return this.provinceAll;
	}

	regioniAll: Regione[];
	async regioniAllPromise(): Promise<Regione[]> {
		if (!this.regioniAll) {
			const r = await this.getAll<Regione>(Regione).toPromise();
			this.regioniAll = _.orderBy(r, "nome");

			// console.info("fetched regioni for cache");
		}
		return this.regioniAll;
	}

	cittadinanzeAll: Cittadinanza[];
	async cittadinanzeAllPromise(): Promise<Cittadinanza[]> {
		if (!this.cittadinanzeAll) {
			const c = await this.getAll<Cittadinanza>(Cittadinanza).toPromise();
			this.cittadinanzeAll = _.orderBy(c, "nome");
			// console.info("fetched cittadinanze for cache");
		}
		return this.cittadinanzeAll;
	}

	professioniAll: Professione[];
	async professioniAllPromise(): Promise<Professione[]> {
		if (!this.professioniAll) {
			const c = await this.getAll<Professione>(Professione).toPromise();
			this.professioniAll = _.orderBy(c, "nome");
			// console.info("fetched professioni for cache");
		}
		return this.professioniAll;
	}

	messaggi_home_all: MessaggioHome[];
	async messaggi_homeAllPromise(): Promise<MessaggioHome[]> {
		if (!this.messaggi_home_all) {
			this.messaggi_home_all = await this.getAll<MessaggioHome>(
				MessaggioHome
			).toPromise();
			// console.info("fetched messaggi for cache");
		}
		return this.messaggi_home_all;
	}

	info_pagina_all: InfoPagina[];
	async info_paginaAllPromise(): Promise<InfoPagina[]> {
		if (!this.info_pagina_all) {
			this.info_pagina_all = await this.getAll<InfoPagina>(
				InfoPagina
			).toPromise();
			// console.info("fetched info_pagine for cache");
		}
		return this.info_pagina_all;
	}

	titoliStudioAll: TitoloStudio[];
	async titoliStudioAllPromise(): Promise<TitoloStudio[]> {
		if (!this.titoliStudioAll) {
			this.titoliStudioAll = await this.getAll<TitoloStudio>(
				TitoloStudio
			).toPromise();
			// console.info("fetched titoli_studi for cache");
		}
		return this.titoliStudioAll;
	}

	macrozoneAll: Macrozona[];
	async macrozoneAllPromise(): Promise<Macrozona[]> {
		if (!this.macrozoneAll) {
			this.macrozoneAll = await this.getAll<Macrozona>(
				Macrozona
			).toPromise();
			// console.info("fetched macrozone for cache");
		}
		return this.macrozoneAll;
	}

	tipoServizioStrutturaAll: TipoServizioStruttura[];
	async tipoServizioStrutturaAllPromise(): Promise<TipoServizioStruttura[]> {
		if (!this.tipoServizioStrutturaAll) {
			this.tipoServizioStrutturaAll =
				await this.getAll<TipoServizioStruttura>(
					TipoServizioStruttura
				).toPromise();
			// console.info("fetched tipo_servizi_struttura for cache");
		}
		return this.tipoServizioStrutturaAll;
	}

	tipologieStrutturaAll: TipologiaStruttura[];
	async tipologieStrutturaAllPromise(): Promise<TipologiaStruttura[]> {
		if (!this.tipologieStrutturaAll) {
			this.tipologieStrutturaAll = await this.getAll<TipologiaStruttura>(
				TipologiaStruttura
			).toPromise();
			// console.info("fetched tipologie_truttura for cache");
		}
		return this.tipologieStrutturaAll;
	}

	struttureAll: Struttura[];
	async struttureAllPromise(): Promise<Struttura[]> {
		if (!this.struttureAll) {
			this.struttureAll = await this.getAll<Struttura>(
				Struttura
			).toPromise();
			// console.info("fetched struttura for cache");
		}
		return this.struttureAll;
	}

	aziendeAll: AziendaSanitaria[];
	async aziendeAllPromise(): Promise<AziendaSanitaria[]> {
		if (!this.aziendeAll) {
			this.aziendeAll = await this.getAll<AziendaSanitaria>(
				AziendaSanitaria
			).toPromise();
			// console.info("fetched aziende for cache");
		}
		return this.aziendeAll;
	}

	areeVasteAll: AreaVasta[];
	async areeVasteAllPromise(): Promise<AreaVasta[]> {
		if (!this.areeVasteAll) {
			this.areeVasteAll = await this.getAll<AreaVasta>(
				AreaVasta
			).toPromise();
			// console.info("fetched aree_vaste for cache");
		}
		return this.areeVasteAll;
	}

	schemiPrestazioneAll: SchemaPrestazione[];
	async schemiPrestazioneAllPromise(): Promise<SchemaPrestazione[]> {
		if (!this.schemiPrestazioneAll) {
			this.schemiPrestazioneAll = await this.getAll<SchemaPrestazione>(
				SchemaPrestazione
			).toPromise();
		}
		return this.schemiPrestazioneAll;
	}

	esamiAll: Esame[];
	async esamiAllPromise(): Promise<Esame[]> {
		if (!this.esamiAll) {
			this.esamiAll = await this.getAll<Esame>(Esame).toPromise();
		}
		return this.esamiAll;
	}

	categoriaEsameAll: CategoriaEsame[];
	async categoriaEsameAllPromise(): Promise<CategoriaEsame[]> {
		if (!this.categoriaEsameAll) {
			this.categoriaEsameAll = await this.getAll<CategoriaEsame>(
				CategoriaEsame
			).toPromise();
		}
		return this.categoriaEsameAll;
	}

	parole_chiaveAll: ParolaChiave[];
	async parole_chiaveAllPromise(): Promise<ParolaChiave[]> {
		if (!this.parole_chiaveAll) {
			this.parole_chiaveAll = await this.getAll<ParolaChiave>(
				ParolaChiave
			).toPromise();
		}
		return this.parole_chiaveAll;
	}

	macrotemaFaqAll: MacrotemaFaq[];
	async macrotemaFaqAllPromise(): Promise<MacrotemaFaq[]> {
		if (!this.macrotemaFaqAll) {
			this.macrotemaFaqAll = await this.getAll<MacrotemaFaq>(
				MacrotemaFaq
			).toPromise();
		}
		return this.macrotemaFaqAll;
	}

	categoriaFaqAll: CategoriaFaq[];
	async categoriaFaqAllPromise(): Promise<CategoriaFaq[]> {
		if (!this.categoriaFaqAll) {
			this.categoriaFaqAll = await this.getAll<CategoriaFaq>(
				CategoriaFaq
			).toPromise();
		}
		return this.categoriaFaqAll;
	}

	sottoCategoriaFaqAll: SottoCategoriaFaq[];
	async sottoCategoriaFaqAllPromise(): Promise<SottoCategoriaFaq[]> {
		if (!this.sottoCategoriaFaqAll) {
			this.sottoCategoriaFaqAll = await this.getAll<SottoCategoriaFaq>(
				SottoCategoriaFaq
			).toPromise();
		}
		return this.sottoCategoriaFaqAll;
	}

	faqAll: Faq[];
	async faqAllPromise(): Promise<Faq[]> {
		if (!this.faqAll) {
			this.faqAll = await this.getAll<Faq>(Faq).toPromise();
		}
		return this.faqAll;
	}

	publicFaqAll: Faq[];
	async publicFaqAllPromise(): Promise<Faq[]> {
		if (!this.publicFaqAll) {
			this.publicFaqAll = await this.getAll<Faq>(
				Faq,
				{},
				0,
				0,
				null,
				false,
				"faq/public"
			).toPromise();
		}
		return this.publicFaqAll;
	}

	private getJSONHeader(): HttpHeaders {
		return new HttpHeaders({
			"Content-Type": "application/json",
		});
	}

	private async setCurrentStrutturaGravidanza(id_struttura) {
		if (id_struttura == null) {
			this.current_struttura_gravidanza = null;
			return;
		}

		if (
			this.current_struttura_gravidanza == null ||
			this.current_struttura_gravidanza.id != id_struttura
		) {
			this.current_struttura_gravidanza = null;
			this.current_struttura_gravidanza = await this.getInstance(
				id_struttura,
				Struttura
			).toPromise();
		}
	}

	async refreshUser(refresh?: boolean) {
		if (refresh) await this.fetchUser(refresh);
		else await this.fetchUser();
	}

	async fetchUser(refresh?: boolean) {
		// await this.resetUserProfile();
		this.current_profilo = null;
		const auth = await this.authService.isAuthenticated().toPromise();

		if (!auth) {
			this._auth_user = null;
			this.current_struttura_gravidanza = null;
			this.auth_userSubject.next(null);
			return;
		}

		// console.log("fetchUser " + JSON.stringify(this.authService.getToken()))
		let urlQueryString = "";
		if (refresh) urlQueryString = "?refresh=true";

		const url = pathJoin([this.baseUrl, "utenti/auth" + urlQueryString]);
		const options = {};
		options["ts"] = +new Date().getTime();

		const user = await this.http
			.get(url, {
				headers: this.getJSONHeader(),
				params: new HttpParams({ fromObject: options }),
			})
			.pipe(
				map(
					(data) => {
						// console.log("CURRENT USER %s", JSON.stringify(data["user"]));
						const u: AuthUser = new AuthUser().deserialize(
							data["user"]
						);
						return u;
					},
					(error) => {
						console.error(
							"CURRENT USER ERROR %s",
							JSON.stringify(error)
						);
						this.router.navigate(["/auth/logout"]);
					}
				)
			)
			.toPromise();

		await user.resolveCapabilities(this);

		if (user) {
			this.setCurrentStrutturaGravidanza(user.consultorio_operatore);
		} else {
			this.setCurrentStrutturaGravidanza(null);
		}
		this._auth_user = user;
		this.auth_userSubject.next(user);
	}

	selectStrutturaPercorsoGravidanza(token: string): Observable<Struttura> {
		// tslint:disable-next-line:quotemark
		const url = this.baseUrl + "/operatori/valida_consultorio";
		const body = { token_accesso: token };

		return this.http.put(url, body, { headers: this.getJSONHeader() }).pipe(
			map(
				(data) => {
					// console.info('CURRENT USER %s', JSON.stringify(data['user']));
					const user: AuthUser = new AuthUser().deserialize(
						data["user"]
					);

					_.assignInWith(new AuthUser(), data["user"]);
					let consultorio: Struttura = null;
					if (data["consultorio"]) {
						consultorio = customDeserializeJson(
							Struttura,
							data["consultorio"]
						);
					}
					this.current_struttura_gravidanza = consultorio;
					this._auth_user = user;
					this.auth_userSubject.next(user);
					return consultorio;
				},
				() => {
					console.error("errore, mail non trovata");
				}
			)
		);
	}

	removeStrutturaPercorsoGravidanza(): Observable<Struttura> {
		return (this.current_struttura_gravidanza = null);
	}

	// RICHIESTA AUTORIZZAZIONE DA PARTE DI MEDICI GENERICI
	richiediAutorizzazioneMedicoGenerico(
		cod_fiscale: string,
		force = false,
		distretto = null,
		cf_medico = null
	) {
		const url =
			this.baseUrl + "/utenti/" + cod_fiscale + "/medico/richiedi";
		const options = {};
		if (force) {
			options["force"] = true;
		}
		if (distretto) {
			options["distretto_team"] = distretto;
		}
		if (cf_medico) {
			options["cf_medico"] = cf_medico;
		}

		return this.http.put(url, null, {
			params: new HttpParams({ fromObject: options }),
			headers: this.getJSONHeader(),
		});
	}

	richiediAutorizzazioneMedicoGenericoLibretto(
		codice_libretto: string,
		force = false,
		distretto = null,
		cf_medico = null
	) {
		const url =
			this.baseUrl +
			"/gravidanze/" +
			codice_libretto +
			"/medico/richiedi";
		const options = {};
		if (force) {
			options["force"] = true;
		}

		if (distretto) {
			options["distretto_team"] = distretto;
		}

		if (cf_medico) {
			options["cf_medico"] = cf_medico;
		}

		return this.http.put(url, null, {
			params: new HttpParams({ fromObject: options }),
			headers: this.getJSONHeader(),
		});
	}

	// RICHIESTA AUTORIZZAZIONE
	richiediAutorizzazioneDistretto(
		cod_fiscale: string,
		id_distretto: number,
		force = false
	) {
		const url =
			this.baseUrl +
			"/utenti/" +
			cod_fiscale +
			"/distretto/" +
			id_distretto +
			"/richiedi";

		const options = {};

		if (force) {
			options["force"] = true;
		}

		return this.http.put(url, null, {
			params: new HttpParams({ fromObject: options }),
			headers: this.getJSONHeader(),
		});
	}

	getStats(
		options: {
			created_from?: string;
			created_to?: string;
			cittadinanza?: string;
			filtro_eta?: string;
			filtro_cittadinanza?: string;
			filtro_titolo_studio?: string;
		} = {}
	): Observable<any> {
		const url = this.baseUrl + "/gravidanze/stats";
		return this.http.post(url, null, {
			params: new HttpParams({ fromObject: options }),
			headers: this.getJSONHeader(),
		});
	}

	getServiceStats(
		options: {
			range_from?: string;
			range_to?: string;
		} = {}
	): Observable<any> {
		const url = this.baseUrl + "/gravidanze/stats/distribuzioni/";
		return this.http.post(url, null, {
			params: new HttpParams({ fromObject: options }),
			headers: this.getJSONHeader(),
		});
	}

	// // FORZA AUTORIZZAZIONE DA PARTE DI AZIENDA SANITARIA
	// forzaAutorizzazioneAziendaSanitaria(cod_fiscale: string) {
	//   const url = this.baseUrl + '/utenti/' + cod_fiscale + '/azienda_sanitaria/richiedi?force=true';
	//   return this.http.put(url, null, { headers: this.getJSONHeader() });
	// }

	// ANNOTAZIONE TOXOTEST E RUBEOTEST

	annotaEsami(id_gravidanza: number, body: any) {
		const url =
			this.baseUrl + "/gravidanze/" + id_gravidanza + "/annota_esami";
		// console.log(body)
		return this.http.put(url, body, {
			headers: this.getJSONHeader(),
		});
	}

	cambiaStatoGravidanza(
		id_gravidanza: number,
		body: any
	): Observable<Gravidanza> {
		const url =
			this.baseUrl + "/gravidanze/" + id_gravidanza + "/cambia_stato";
		// console.log(body)
		return this.http
			.put(url, body, {
				headers: this.getJSONHeader(),
			})
			.pipe(
				map((response) =>
					customDeserializeJson(Gravidanza, response["gravidanza"])
				)
			);
	}

	ridatazioneGravidanza(
		id_gravidanza: number,
		body: any
	): Observable<Gravidanza> {
		const url =
			this.baseUrl +
			"/gravidanze/" +
			id_gravidanza +
			"/ridatazione_ecografica";
		// console.log(body)
		return this.http
			.put(url, body, {
				headers: this.getJSONHeader(),
			})
			.pipe(
				map((response) =>
					customDeserializeJson(Gravidanza, response["gravidanza"])
				)
			);
	}

	correggiDataGravidanza(id_gravidanza: number, body: any) {
		const url =
			this.baseUrl +
			"/gravidanze/" +
			id_gravidanza +
			"/correggi_ultima_mestruazione";
		return this.http
			.put(url, body, {})
			.pipe(
				map((response) =>
					customDeserializeJson(Gravidanza, response["gravidanza"])
				)
			);
	}

	annullaRidatazioneGravidanza(id_gravidanza: number) {
		const url =
			this.baseUrl +
			"/gravidanze/" +
			id_gravidanza +
			"/annulla_ridatazione";
		return this.http
			.put(
				url,
				{},
				{
					headers: this.getJSONHeader(),
				}
			)
			.pipe(
				map((response) =>
					customDeserializeJson(Gravidanza, response["gravidanza"])
				)
			);
	}

	aggiornaAltezzaPeso(
		gravidanza: Gravidanza,
		altezza: number,
		peso: number,
		classe_peso: string
	) {
		const url =
			this.baseUrl +
			"/gravidanze/" +
			gravidanza.id +
			"/forced_update?message=aggiorna";
		return this.http
			.put(
				url,
				{
					altezza: altezza,
					peso_iniziale: peso,
					classe_peso: classe_peso,
				},
				{
					headers: this.getJSONHeader(),
				}
			)
			.pipe(
				map((response) => customDeserializeJson(Gravidanza, response))
			);
	}

	listaGravidanze(
		filters: any,
		offset: number = null,
		limit: number = null,
		nascita: boolean = false
	): Observable<{ gravidanze: any[]; full_count: number }> {
		let url = this.baseUrl + "/gravidanze/lista?";

		if (offset) {
			url += "offset=" + offset + "&";
		}

		if (limit) {
			url += "limit=" + limit + "&";
		}

		if (nascita) {
			url += "nascita=" + nascita;
		}

		return this.http.post<{ gravidanze: any[]; full_count: number }>(
			url,
			filters,
			{
				headers: this.getJSONHeader(),
			}
		); // .pipe(map(response => response['gravidanze']));
	}

	mandaMailAdAssistenza(email: string, categoria: string, messaggio: string) {
		// console.log("assistenza per utente con mail" + email)

		const url = this.baseUrl + "/feedback";

		const body = {
			email: email,
			topic: categoria,
			message: messaggio,
			platform: "web_admin",
			platform_version: "-",
		};

		// console.log(url)
		return this.http.put(url, body, { headers: this.getJSONHeader() }).pipe(
			map(
				(data) => {
					// console.log("Richiesta effettuata");
					return data;
				},
				(responseError) => {
					console.error(responseError);
				}
			)
		);
	}

	richiediAutorizzazioneAziendaSanitaria(
		cod_fiscale: string,
		force: boolean = false
	) {
		// console.log("autorizzazione azienda sanitaria per utente con cf " + cod_fiscale)
		let url =
			this.baseUrl +
			"/utenti/" +
			cod_fiscale +
			"/azienda_sanitaria/richiedi";
		if (force) url += "?force=true";

		// console.log(url)
		return this.http
			.put(url, null, { headers: this.getJSONHeader() })
			.subscribe(
				(data) => {
					// console.log("Richiesta di autorizzazione azienda sanitaria presa in carico");
				},
				(responseError) => {
					console.error(responseError);
				}
			);
	}

	sendRequestPassword(email: string, username: string) {
		if (!email && !username) {
			return;
		}

		const options = {};
		if (email) {
			options["email"] = email;
		}
		if (username) {
			options["username"] = username;
		}

		options["ts"] = +new Date().getTime();

		const url = this.baseUrl + "/utenti/password";
		return this.http
			.get(url, {
				headers: this.getJSONHeader(),
				params: new HttpParams({ fromObject: options }),
			})
			.pipe(
				map(
					(response) => {
						return response;
					},
					() => {
						console.error("errore, mail non trovata");
					}
				)
			);
	}

	resetPassword(code: string, password: string) {
		const url = this.baseUrl + "/utenti/password";
		const body = { code: code, password: password };
		return this.http
			.post(url, body, { headers: this.getJSONHeader() })
			.pipe(
				map(
					(response) => {
						return response;
					},
					() => {
						console.error("errore, reset non riuscito");
					}
				)
			);
	}

	constructor(
		private http: HttpClient,
		private router: Router,
		private authService: NbAuthService
	) {
		this.authService.onAuthenticationChange().subscribe(() => {
			this.fetchUser();
		});

		// console.log('istanziato service HappyMammaService');

		this.getLingue().subscribe((lingue) => {
			/*console.log(lingue)*/
		});
	}

	async prefetch() {
		const cittadinanze = await this.cittadinanzeAllPromise();
		const aziende = await this.cittadinanzeAllPromise();
		const aree = await this.areeVasteAllPromise();
		const regione = await this.regioniAllPromise();
		const profs = await this.professioniAllPromise();
		const titoli = await this.titoliStudioAllPromise();
		const distretti = await this.distrettiAllPromise();
		const macros = await this.macrozoneAllPromise();
		const tipo_struc = await this.tipologieStrutturaAllPromise();
		const structs = await this.struttureAllPromise();
		const provs = await this.provinceAllPromise();
		const comuni = await this.comuniAllPromise();
		
		// let infos = await this.info_paginaAllPromise();
		// let msgs = await this.messaggi_homeAllPromise();
	}

	async areaVastaByRef(ref: number | AreaVasta): Promise<AreaVasta> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof AreaVasta) {
			return ref;
		}
		const elems = await this.areeVasteAllPromise();
		return _.find(elems, { id: +ref });
	}

	async aziendaSanitariaByRef(
		ref: number | AziendaSanitaria
	): Promise<AziendaSanitaria> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof AziendaSanitaria) {
			return ref;
		}
		const elems = await this.aziendeAllPromise();
		return _.find(elems, { id: +ref });
	}

	async aziendaSanitariaByAreaVasta(
		ref: number | AreaVasta
	): Promise<AziendaSanitaria[]> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof AreaVasta) {
			ref = ref.id;
		}
		const elems = await this.aziendeAllPromise();
		return _.filter(elems, { area_vasta: +ref });
	}

	async macrozonaByRef(ref: number | Macrozona): Promise<Macrozona> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof Macrozona) {
			return ref;
		}
		const elems = await this.macrozoneAllPromise();
		return _.find(elems, { id: +ref });
	}

	async macrozoneByAziendaSanitaria(
		ref: number | AziendaSanitaria
	): Promise<Macrozona[]> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof AziendaSanitaria) {
			ref = ref.id;
		}
		const elems = await this.macrozoneAllPromise();
		return _.filter(elems, { azienda_sanitaria: +ref });
	}

	async distrettoByRef(ref: number | Distretto): Promise<Distretto> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof Distretto) {
			return ref;
		}
		const elems = await this.distrettiAllPromise();
		return _.find(elems, { id: +ref });
	}

	async distrettiByMacrozona(ref: number | Macrozona): Promise<Distretto[]> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof Macrozona) {
			ref = ref.id;
		}
		const elems = await this.distrettiAllPromise();
		return _.filter(elems, { macrozona: +ref });
	}

	async strutturaByRef(ref: number | Struttura): Promise<Struttura> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof Struttura) {
			return ref;
		}
		const elems = await this.struttureAllPromise();
		return _.find(elems, { id: +ref });
	}

	async struttureByDistretto(ref: number | Distretto): Promise<Struttura[]> {
		if (ref == null) {
			return null;
		}

		if (ref instanceof Distretto) {
			ref = ref.id;
		}
		const elems = await this.struttureAllPromise();
		return _.filter(elems, { distretto: +ref });
	}

	resolveProvincia(provincia: number | Provincia): Provincia {
		if (provincia == null) {
			return null;
		}

		if (provincia instanceof Provincia) {
			return provincia;
		}
		return _.find(this.provinceAll, {
			id: +provincia,
		});
	}

	resolveRegione(regione: number | Regione): Regione {
		if (regione == null) {
			return null;
		}

		if (regione instanceof Regione) {
			return regione;
		}
		return _.find(this.regioniAll, {
			id: +regione,
		});
	}

	resolveComune(comune: number | Comune): Comune {
		if (comune == null) {
			return null;
		}

		if (comune instanceof Comune) {
			return comune;
		}
		return _.find(this.comuniAll, {
			id: +comune,
		});
	}

	getFirst<T extends HmModelRest>(
		classType: HmRestType<T>,
		filters: {} = {},
		limit: number = 0,
		offset: number = 0,
		orderby: string[] = null,
		ext: boolean = false
	): Observable<T> {
		return this.getAll<T>(
			classType,
			filters,
			limit,
			offset,
			orderby,
			ext
		).pipe(map(filterFirst));
	}

	// utenti?orderby=nome,-cognome&offset=4&limit=10&ext=true
	getAll<T extends HmModelRest>(
		classType: HmRestType<T>,
		filters: {} = {},
		limit: number = 0,
		offset: number = 0,
		orderby: string[] = null,
		ext: boolean = false,
		rest_path: string = null
	): Observable<T[]> {
		if (classType.rest_path == undefined) {
			console.error("missing rest_path for " + classType);
		}

		if (!rest_path) {
			rest_path = classType.rest_path;
		}
		let url = pathJoin([this.baseUrl, rest_path]);
		if (ext) {
			url += "?ext=true";
		}
		const params = [];

		if (offset) params.push("offset=" + offset);

		if (limit) params.push("limit=" + limit);

		// ci vorrebbe escape
		if (orderby && orderby.length > 0)
			params.push("orderby=" + orderby.join(","));

		if (params.length > 0) url += "?" + params.join("&");

		const body = filters;

		return this.http
			.post<T[]>(url, body, { headers: this.getJSONHeader() })
			.pipe(
				map((entries) =>
					entries.map((entry) =>
						customDeserializeJson(classType, entry)
					)
				)
			);
	}

	// utenti?orderby=nome,-cognome&offset=4&limit=10&ext=true
	getAllAndCount<T extends HmModelRest>(
		classType: HmRestType<T>,
		filters: {} = {},
		limit: number = 0,
		offset: number = 0,
		orderby: string[] = null
	): Observable<{ data: T[]; tot: number }> {
		if (classType.rest_path == undefined)
			console.error("missing rest_path for " + classType);

		let url = pathJoin([this.baseUrl, classType.rest_path]);
		const params = [];

		if (offset) params.push("offset=" + offset);

		if (limit) params.push("limit=" + limit);

		// ci vorrebbe escape
		if (orderby && orderby.length > 0)
			params.push("orderby=" + orderby.join(","));

		if (params.length > 0) url += "?" + params.join("&");

		const body = filters;

		/*
      console.info(
      'getAllAndCount %s -> %s (%s)',
      classType.rest_path,
      JSON.stringify(body),
      url,
    );
    */

		return this.http
			.post<T[]>(url, body, {
				headers: this.getJSONHeader(),
				observe: "response",
			})
			.pipe(
				map((response) => {
					const tot = parseInt(
						response.headers.get("x-total-count"),
						10
					);
					const data = [];
					const resp = { data: data, tot: tot };

					response.body.forEach((entry) =>
						data.push(customDeserializeJson(classType, entry))
					);

					return resp;
				})
			);
	}

	getInstance<T extends HmModelRest>(
		id: number,
		classType: HmRestType<T>,
		ext: boolean = false
	): Observable<T> {
		if (classType.rest_path == undefined) {
			console.error("missing rest_path for " + classType.rest_path);
			throw new Error("missing rest_path for " + classType.rest_path);
		}

		// console.log(this.baseUrl)
		let url = pathJoin([this.baseUrl, classType.rest_path]);
		if (ext) {
			url += "?ext=true";
		}
		const body = { id: id };
		return this.http
			.post<T[]>(url, body, { headers: this.getJSONHeader() })
			.pipe(
				map(filterFirst),
				map((json) => customDeserializeJson(classType, json))
			);
	}

	deleteInstance<T extends HmModelRest>(
		id: number,
		classType: HmRestType<T>
	): Observable<any> {
		// il body è un po' un casino nelle DELETE
		// risolvo così

		const url = pathJoin([this.baseUrl, classType.rest_path]);

		// console.log("delete %s.%d (%s)", classType.rest_path, id, url);

		const req = new HttpRequest("DELETE", url);

		const newReq = req.clone({
			body: { id: id },
			headers: this.getJSONHeader(),
		});
		return this.http.request(newReq);
	}

	update<T extends HmModelRest>(
		id: number,
		body: any,
		classType: HmRestType<T>
	): Observable<T> {
		if (classType.rest_path == undefined) {
			console.error("missing rest_path for " + classType.rest_path);
		}
		// console.log(this.baseUrl)
		const url = pathJoin([this.baseUrl, classType.rest_path]);

		body = body || {};
		body.id = id;

		return this.http
			.put<T>(url, body, {
				headers: this.getJSONHeader(),
			})
			.pipe(
				map(filterFirst),
				map((json) => customDeserializeJson(classType, json))
			);
	}

	createOrUpdate<T extends HmModelRest>(
		instance: T,
		classType: HmRestType<T>
	): Observable<T> {
		if (classType.rest_path == undefined) {
			console.error("missing rest_path for " + classType.rest_path);
		}

		const url = pathJoin([this.baseUrl, classType.rest_path]);
		const body = instance;

		console.info(
			"createOrUpdate %s-> %s (%s)",
			classType.rest_path,
			JSON.stringify(body),
			url
		);

		return this.http
			.put<T>(url, body, {
				headers: this.getJSONHeader(),
			})
			.pipe(
				map(filterFirst),
				map((json) => customDeserializeJson(classType, json))
			);
	}

	// admin e operatori
	validaPrescrizioni(data: any, id: number) {
		const url = this.baseUrl + "/prescrizione/" + id + "/valida";
		const body = data;
		return this.http.put(url, body, { headers: this.getJSONHeader() }).pipe(
			map((response) => {
				return response;
			})
		);
	}

	// solo admin
	annullaPrescrizioni(id: number, msg: string) {
		let url = this.baseUrl + "/prescrizione/" + id + "/annulla";
		if (msg) {
			url += "?message=" + encodeURIComponent(msg);
		}
		return this.http.post(url, {}, { headers: this.getJSONHeader() }).pipe(
			map((response) => {
				return response;
			})
		);
	}

	createOrUpdateList<T extends HmModelRest>(
		instance: T[],
		classType: HmRestType<T>
	): Observable<T[]> {
		const url = pathJoin([this.baseUrl, classType.rest_path]);
		const body = instance;

		return this.http
			.put<T[]>(url, body, {
				headers: this.getJSONHeader(),
			})
			.pipe(
				map((entries) =>
					entries.map((entry) =>
						customDeserializeJson(classType, entry)
					)
				)
			);
	}

	/** Log a HeroService message with the MessageService */
	private log(message: string) {
		// console.log(message);
		// this.messageService.add('HeroService: ' + message);
	}

	lingue: LinguaSistema[];
	tipologie_struttura: TipologiaStruttura[];
	server_version: string;

	getLingue(): Observable<LinguaSistema[]> {
		if (this.lingue) return of(this.lingue);

		return this.getDefines().pipe(
			map((data) => {
				this.lingue = data["lingue"];
				this.tipologie_struttura = data["tipologie_struttura"];
				this.server_version = data["version"] || "prod";
				return data["lingue"];
			})
		);
	}

	getLibrettoPrescrizione(gravidanza_id: number, prescrizione_id: number) {
		const url = pathJoin([
			this.baseUrl,
			"gravidanze/",
			"" + gravidanza_id,
			"libretto",
			"" + prescrizione_id,
		]);

		return this.http.get(url, { responseType: "blob" });
	}

	scaricaLibrettoCartaceo() {
		const url = "/assets/documents/libretto_gravidanza.pdf";
		return this.http.get(url, { responseType: "blob" });
	}

	scaricaNoteLibretto() {
		const url = "/assets/documents/note_libretto_gravidanza.pdf";
		return this.http.get(url, { responseType: "blob" });
	}

	getCertificatoGravidanza(gravidanza_id: number) {
		const url = pathJoin([
			this.baseUrl,
			"gravidanze/" + gravidanza_id + "/certificato",
		]);

		return this.http.get(url, { responseType: "blob" });
	}

	getSchedaRitiroGravidanza(gravidanza_id: number) {
		const url = pathJoin([
			this.baseUrl,
			"gravidanze/" + gravidanza_id + "/scheda_ritiro",
		]);

		return this.http.get(url, { responseType: "blob" });
	}

	getCalendarioGravidanza(gravidanza_id: number) {
		const url = pathJoin([
			this.baseUrl,
			"gravidanze/" + gravidanza_id + "/pdf",
		]);

		return this.http.get(url, { responseType: "blob" });
	}

	getDefines(): Observable<
		{ lingue: LinguaSistema[]; tipologie_struttura: TipologiaStruttura[] }[]
	> {
		const url = pathJoin([this.baseUrl, "defines"]);
		return this.http.get<
			{
				lingue: LinguaSistema[];
				tipologie_struttura: TipologiaStruttura[];
			}[]
		>(url, { headers: this.getJSONHeader() });
	}

	getUtenteCodFisc(codice_fiscale: string): Observable<Utente> {
		const url = pathJoin([
			this.baseUrl,
			"utenti/per_codice_fiscale/?cod_fiscale=" + codice_fiscale,
		]);
		return this.http.get<Utente>(url, { headers: this.getJSONHeader() });
	}

	getGravidanzaLibretto(codice_libretto: string): Observable<Gravidanza> {
		const url = pathJoin([
			this.baseUrl,
			"gravidanze/per_codice_libretto/?codice_libretto=" +
				codice_libretto,
		]);
		return this.http.get<Gravidanza>(url, {
			headers: this.getJSONHeader(),
		});
	}

	auth_userSubject = new Subject<any>();

	public auth_user$ = this.auth_userSubject.asObservable();

	_auth_user: AuthUser;

	get auth_user(): AuthUser {
		return this._auth_user;
	}

	interrogaRFC249(cod_fiscale: string): Observable<Object> {
		const url = pathJoin([
			this.baseUrl,
			"rfc249?cod_fiscale=" + cod_fiscale,
		]);

		return this.http
			.get<{ anagrafica: Object }>(url, { headers: this.getJSONHeader() })
			.pipe(
				map(
					(data) => {
						// console.log(data["anagrafica"])
						return data["anagrafica"];
					},
					(error) => {
						console.error("rotto %s", JSON.stringify(error));
					}
				)
			);
	}

	generaTokenStruttura(index: number): Observable<string> {
		const url = pathJoin([
			this.baseUrl,
			Struttura.rest_path,
			String(index),
			"reset_token",
		]);

		return this.http
			.post<{ token: string }>(url, { headers: this.getJSONHeader() })
			.pipe(
				map(
					(data) => {
						// console.log("generaTokenStruttura %s", JSON.stringify(data));
						return data["token"];
					},
					(error) => {
						console.error("rotto %s", JSON.stringify(error));
					}
				)
			);
	}

	// webapp users
	public changeDoctorAuthorization(
		cf_medico: string,
		denominazione: string,
		role: string,
		new_status: string
	) {
		const body = {
			cf_medico: cf_medico,
			denominazione: denominazione,
			ruolo: role,
		};
		let url = this.baseUrl + "/utenti/medico/";
		if (new_status == "authorized") {
			url += "autorizza";
		} else {
			url += "nega";
		}
		return this.http.put(url, body);
	}

	public changeDistrictAuthorization(
		id_distretto: number,
		new_status: string
	) {
		const body = {};

		let url = this.baseUrl + "/utenti/distretto/" + id_distretto;
		if (new_status == "authorized") {
			url += "/autorizza";
		} else {
			url += "/nega";
		}
		return this.http.put(url, body);
	}

	sendAuthenticatedFeedback(body: any) {
		return this.http.put(this.baseUrl + "/utenti/feedback/", body);
	}

	async resetUserProfile() {
		this.current_profilo = null;
		await this.getCurrentUserProfile(true);
	}

	current_profilo: ProfiloUtente;
	async getCurrentUserProfile(
		force: boolean = false
	): Promise<ProfiloUtente> {
		if (force || !this.current_profilo) {
			this.current_profilo = await this.http
				.get(this.baseUrl + "/utenti/me/")
				.pipe(
					map((response) => new ProfiloUtente().deserialize(response))
				)
				.toPromise();
		}
		return this.current_profilo;
	}

	async getUserProfile(id: number): Promise<ProfiloUtente> {
		const response = await this.http
			.get<ProfiloUtente>(this.baseUrl + "/utenti/" + id + "/profilo", {
				headers: this.getJSONHeader(),
			})
			.toPromise();

		return new ProfiloUtente().deserialize(response);
	}

	saveUtente(utente: any) {
		return this.http.put(this.baseUrl + "/utenti/me/", utente);
	}

	addEntryPeso(body: any) {
		return this.http.put(this.baseUrl + "/entry_peso/", body);
	}

	sendFeedback(body: any) {
		return this.http.put(this.baseUrl + "/feedback/", body);
	}

	getPrescrizioniCup(cod_fiscale): Observable<PrescrizioneCup[]> {
		let url = "/cup/prenotazioni/";

		if (cod_fiscale) {
			url += "cod_fiscale/" + cod_fiscale;
		} else {
			url += "me";
		}

		return this.http
			.get(this.baseUrl + url)
			.pipe(
				map((response) =>
					response["prescrizioni"].map((item) =>
						new PrescrizioneCup().deserialize(item)
					)
				)
			);
	}

	getAppuntamentiCup(
		filters: AppuntamentiFilters
	): Observable<AppuntamentoCup[]> {
		let url = "/cup/ricerca/me";

		return this.http
			.post(this.baseUrl + url, filters)
			.pipe(
				map((response) =>
					response["lista_disponibilita"].map((item) =>
						new AppuntamentoCup().deserialize(item)
					)
				)
			);
	}

	getAppuntamentiCupCodFiscale(
		filters: AppuntamentiFilters,
		codice_fiscale: string
	): Observable<AppuntamentoCup[]> {
		let url = "/cup/ricerca/cod_fiscale/" + codice_fiscale;

		return this.http
			.post(this.baseUrl + url, filters)
			.pipe(
				map((response) =>
					response["lista_disponibilita"].map((item) =>
						new AppuntamentoCup().deserialize(item)
					)
				)
			);
	}

	postAppuntamentoCup(
		appuntamento: AppuntamentoCup,
		codice_libretto: string,
		codice_nre: string
	): Observable<AgendaUtente> {
		let payload = {
			appuntamento: appuntamento,
			codice_libretto: codice_libretto,
			codice_nre: codice_nre,
		};
		let url = "/cup/prenota/me";

		return this.http
			.put<AgendaUtente>(this.baseUrl + url, payload)
			.pipe(map((response) => (response = response["agenda_utente"])));
	}

	postAppuntamentoCupCodFiscale(
		appuntamento: AppuntamentoCup,
		codice_libretto: string,
		codice_nre: string,
		codice_fiscale: string
	): Observable<AgendaUtente> {
		let payload = {
			appuntamento: appuntamento,
			codice_libretto: codice_libretto,
			codice_nre: codice_nre,
		};
		let url = "/cup/prenota/cod_fiscale/" + codice_fiscale;

		return this.http
			.put<AgendaUtente>(this.baseUrl + url, payload)
			.pipe(map((response) => (response = response["agenda_utente"])));
	}

	deleteAppuntamentoCup(id_appuntamento: string): Observable<AgendaUtente> {
		let payload = {
			id_appuntamento: id_appuntamento,
		};
		let url = "/cup/cancella_appuntamento/me";

		return this.http
			.put<AgendaUtente>(this.baseUrl + url, payload)
			.pipe(map((response) => (response = response["agenda_utente"])));
	}

	deleteAppuntamentoCupCodFiscale(
		id_appuntamento: string,
		codice_fiscale: string
	): Observable<AgendaUtente> {
		let payload = {
			id_appuntamento: id_appuntamento,
		};
		let url = "/cup/cancella_appuntamento/cod_fiscale/" + codice_fiscale;

		return this.http
			.put<AgendaUtente>(this.baseUrl + url, payload)
			.pipe(map((response) => (response = response["agenda_utente"])));
	}

	verifica_medico(
		cod_fiscale: string = null
	): Observable<DescrizioneMedicoFamiglia> {
		let url = pathJoin([this.baseUrl, "utenti/verifica_medico_generico/"]);
		if (cod_fiscale) {
			url += "?cod_fiscale=" + cod_fiscale;
		}

		return this.http.get<DescrizioneMedicoFamiglia>(url);
	}
	/*
  public handleErrorGeneric(error: Response) {
    console.error(error);
    return observableThrowError(error.statusText || 'Server error');
  }
  */
	scaricaXlsxTeamOperatoriDistretto() {
		const url = this.baseUrl + "/team_operatori_distretti/dump";
		const headers = new HttpHeaders();
		headers.set("Content-Type", "application/json");
		headers.set(
			"Accept",
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
		);
		return this.http.post(url, { headers: headers, responseType: "blob" });
	}

	async entityFromCapability(
		capability: UserCapability
	): Promise<
		AreaVasta | AziendaSanitaria | Macrozona | Distretto | Struttura
	> {
		switch (capability.entity_type) {
			case CapabilityType.AREA_VASTA:
				return await this.areaVastaByRef(capability.entity_id);
			case CapabilityType.AZIENDA_SANITARIA:
				return await this.aziendaSanitariaByRef(capability.entity_id);
			case CapabilityType.MACROZONA:
				return await this.macrozonaByRef(capability.entity_id);
			case CapabilityType.DISTRETTO:
				return await this.distrettoByRef(capability.entity_id);
			case CapabilityType.STRUTTURA:
				return await this.strutturaByRef(capability.entity_id);
			default:
				return null;
		}
	}

	getOtp(): Observable<string> {
		const url = this.baseUrl + "/utenti/otp";
		return this.http.get<{ otp: string }>(url).pipe(map((x) => x.otp));
	}

	listUsers(
		filters: {} = {},
		limit: number = 0,
		offset: number = 0,
		orderby: string[] = null
	): Observable<{
		tot: number;
		utenti: UserListEntry[];
	}> {
		let url = pathJoin([this.baseUrl, "utenti/lista"]);
		const dict_params = {};

		if (offset) {
			dict_params["offset"] = +offset;
		}
		if (limit) {
			dict_params["limit"] = +limit;
		}
		if (orderby) {
			dict_params["orderby"] = orderby;
		}

		const body = filters;
		return this.http.post<{
			tot: number;
			utenti: UserListEntry[];
		}>(url, body, {
			params: new HttpParams({ fromObject: dict_params }),
			headers: this.getJSONHeader(),
		});
	}

	listOperators(
		filters: {} = {},
		limit: number = 0,
		offset: number = 0,
		orderby: string[] = null
	): Observable<{
		tot: number;
		operatori: Operatore[];
	}> {
		let url = pathJoin([this.baseUrl, "operatori/lista"]);
		const dict_params = {};

		if (offset) {
			dict_params["offset"] = +offset;
		}
		if (limit) {
			dict_params["limit"] = +limit;
		}
		if (orderby) {
			dict_params["orderby"] = orderby;
		}

		const body = filters;
		return this.http.post<{
			tot: number;
			operatori: Operatore[];
		}>(url, body, {
			params: new HttpParams({ fromObject: dict_params }),
			headers: this.getJSONHeader(),
		});
	}

	userCapabilities(username: string): Observable<UserCapability[]> {
		let url = pathJoin([
			this.baseUrl,
			"operatori",
			username,
			"capabilities",
		]);
		const dict_params = {};

		const body = {};
		return this.http
			.post<{
				capabilities: UserCapability[];
			}>(url, body, {
				params: new HttpParams({ fromObject: dict_params }),
				headers: this.getJSONHeader(),
			})
			.pipe(
				map((resp) => {
					console.log("capabs", resp);
					return resp.capabilities;
				})
			);
	}

	removeCapability(operatore: Operatore, capability: UserCapability) {
		const url = pathJoin([
			this.baseUrl,
			"operatori",
			operatore.username,
			"capability",
			"delete",
		]);

		// let body = {
		//   user_identifier: operatore.username,
		//   user_role: capability.user_role,
		//   entity_type: capability.entity_type,
		//   entity_id: capability.entity_id
		// }

		const body = capability;

		return this.http.post(url, body, {
			headers: this.getJSONHeader(),
		});
	}

	checkNreValidation(nre_code: string, fiscal_code: string) {
		const url = pathJoin([this.baseUrl, "nre", "verifica_nre"]);

		const body = {
			nre_code: nre_code,
			cod_fiscale: fiscal_code,
		};

		return this.http
			.post(url, body, {
				headers: this.getJSONHeader(),
			})
			.pipe();
	}

	checkPrescrizioneNreValidation(id_prescrizione: number) {
		const url = pathJoin([
			this.baseUrl,
			"prescrizione",
			id_prescrizione.toString(),
			"verifica_nre",
		]);

		return this.http
			.post(
				url,
				{},
				{
					headers: this.getJSONHeader(),
				}
			)
			.pipe();
	}

	addCapability(operatore: Operatore, capability: UserCapability) {
		const url = pathJoin([
			this.baseUrl,
			"operatori",
			operatore.username,
			"capabilities",
		]);

		const body = capability;

		return this.http
			.put<UserCapability>(url, body, {
				headers: this.getJSONHeader(),
			})
			.pipe(
				map(filterFirst)
				//map(json => customDeserializeJson(UserCapability, json)));
			);
		// let body = {
		//   user_identifier: operatore.username,
		//   user_role: capability.user_role,
		//   entity_type: capability.entity_type,
		//   entity_id: capability.entity_id
		// }
	}

	async syncWithCup(): Promise<ProfiloUtente> {
		this.current_profilo = await this.http
			.get(this.baseUrl + "/cup/sync/me/")
			.pipe(map((response) => new ProfiloUtente().deserialize(response)))
			.toPromise();

		return this.current_profilo;
	}

	createMoodleUser(
		email: string,
		firstname: string,
		lastname: string,
		course_id?: number,
		group_id?: number
	): Observable<any> {
		const url = this.baseUrl + "/moodle/users/create";
		const body = {
			email: email,
			firstname: firstname,
			lastname: lastname,
		};
		if (group_id && course_id) {
			body["group_id"] = group_id;
			body["course_id"] = course_id;
		}

		return this.http.put(url, body, { headers: this.getJSONHeader() });
	}

	getCategorieAssistenza(): Observable<CategoriaAssistenza[]> {
		const url = this.baseUrl + "/categorie_assistenza/";
		return this.http.get<CategoriaAssistenza[]>(url);
	}

	getOperatoriDistretto(
		distretto_id: number
	): Observable<OperatoreDistretto[]> {
		const url = pathJoin([
			this.baseUrl,
			"utenti",
			"capability",
			"nascita",
			distretto_id.toString(),
		]);
		return this.http.get<OperatoreDistretto[]>(url);
	}

	isAuthorized(
		capability_role: CapabilityRole,
		capability_category: CapabilityType,
		category_id: number
	): boolean {
		return this.auth_user.isAuthorized(
			capability_role,
			capability_category,
			category_id
		);
	}

	isAuthorizedByCategory(
		capability_role: CapabilityRole,
		capability_category: CapabilityType
	): boolean {
		return this.auth_user.isAuthorizedByCategory(
			capability_role,
			capability_category
		);
	}

	isAuthorizedByRole(capability_role: CapabilityRole): boolean {
		return this.auth_user.isAuthorizedByRole(capability_role);
	}

	getDashboardStats(): Observable<any> {
		const url = pathJoin([this.baseUrl, "gravidanze/stats/dashboard"]);
		return this.http.post<any>(url, { headers: this.getJSONHeader() });
	}
}
